import React from 'react';
interface OptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  sizes?: string;
  loading?: "lazy" | "eager";
  priority?: boolean;
}
const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  className = "",
  sizes = "100vw",
  loading = "lazy",
  priority = false
}) => {
  // Generate responsive image URLs for different sizes
  const generateSrcSet = (originalSrc: string) => {
    if (originalSrc.includes('unsplash.com')) {
      // For Unsplash images, use their built-in resizing
      const baseUrl = originalSrc.split('?')[0];
      return `${baseUrl}?w=400&h=300&fit=crop&fm=webp&q=80 400w, ${baseUrl}?w=800&h=600&fit=crop&fm=webp&q=80 800w, ${baseUrl}?w=1200&h=900&fit=crop&fm=webp&q=80 1200w`;
    } else {
      // For local images, generate responsive variants
      const extension = originalSrc.split('.').pop()?.toLowerCase();
      if (extension && ['jpg', 'jpeg', 'png'].includes(extension)) {
        // Generate multiple sizes for better responsive loading
        return `${originalSrc} 1x, ${originalSrc} 2x`;
      }
      return `${originalSrc} 1x`;
    }
  };
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      srcSet={generateSrcSet(src)}
      sizes={sizes}
      loading={priority ? "eager" : loading}
      {...(priority ? { fetchPriority: "high" as const } : {})}
      decoding="async"
    />
  );
};
export default OptimizedImage;
export { OptimizedImage };
export type { OptimizedImageProps };